import { useSelector } from "react-redux";
import { PostForm } from "./PostForm";

const CreatePostForm = () => {
  const files = useSelector((state: any) => state.postContent.files);

  return <PostForm files={files} />;
};
export { CreatePostForm };
